var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "profileEditModal",
        size: "md",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("message.profile_update"),
      },
      on: { show: _vm.getSelf, hidden: _vm.resetValues },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.updateUser()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.update")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("b-input-group-form-input", {
        attrs: {
          id: "fullname-input",
          "input-group-size": "mb-3",
          type: "text",
          lazy: "true",
          required: "true",
          feedback: "true",
          autofocus: "false",
          label: _vm.$t("message.fullname"),
          "feedback-text": _vm.$t("admin.required_fullname"),
        },
        model: {
          value: _vm.fullname,
          callback: function ($$v) {
            _vm.fullname = $$v
          },
          expression: "fullname",
        },
      }),
      _c("b-input-group-form-input", {
        attrs: {
          id: "email-input",
          "input-group-size": "mb-3",
          type: "text",
          lazy: "true",
          required: "true",
          feedback: "true",
          autofocus: "false",
          label: _vm.$t("message.email"),
          "feedback-text": _vm.$t("admin.required_email"),
        },
        model: {
          value: _vm.email,
          callback: function ($$v) {
            _vm.email = $$v
          },
          expression: "email",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }